import { useTranslation } from '../../../utils/useTranslation';
import { Skeleton } from '../../feedback/Skeleton';
import { Typography } from '../../typography/Typography';
import { ContentPromotionLoginContent } from './parts/ContentPromotionLoginContent/ContentPromotionLoginContent';
import { Wrapper } from './styles';
import { ContentPromotionLoginProps } from './types';

export const ContentPromotionLogin: React.FC<ContentPromotionLoginProps> = ({
    options,
    value,
    isLoaging,
    onChange,
    ...other
}) => {
    const t = useTranslation();

    return (
        <Wrapper {...other}>
            <Typography variant="title3" weight="bold">
                {t('Аккаунт в Директе')}
            </Typography>
            {isLoaging ? (
                <Skeleton mt={2} variant="text" width="40%" height={50} />
            ) : (
                <ContentPromotionLoginContent options={options} value={value} onChange={onChange} />
            )}
        </Wrapper>
    );
};
